export const config = {
	jwt: {
		encryptionKey: 'WXIfBP9Aq5cLbLv9aDyUR3uVq79kDIeR',
		initialisationVector: 'QnQo5dObEdup0bS0',
	},
	apiHost: 'https://twanimal.vogeslu.de',
	//apiHost: 'http://localhost:8080',
	giphyApiToken: 'hNN5XF0X6WYK8m6J8DDadcgA210hHhvF',
};
